export default __webpack_public_path__ + "static/appstore-2448a244a3ad0cad285048ca74bd3b2e.svg";